import { ThemeProvider } from '@metservicedev/met-ui';
import * as React from 'react';

import { ApiProvider } from './ApiProvider';
import { AppConfigProvider } from './AppConfigProvider';
import { AuthProvider } from './AuthProvider';

type Props = {
  children: React.ReactNode;
};

export const AppContexts: React.FC<Props> = ({ children }) => (
  <ThemeProvider>
    <AppConfigProvider>
      <AuthProvider>
        <ApiProvider>
          {children}
        </ApiProvider>
      </AuthProvider>
    </AppConfigProvider>
  </ThemeProvider>
);
